import React from 'react';
import { useRouter } from '../../hooks';
import HeaderMeta from '../../components/HeaderMeta';
import { SCORE_REPORT_VALIDATION_URL } from '../../constants';

import './styles.scss';

const ScoreReportVerification = () => {
  const { lang } = useRouter();

  return (
    <>
      <HeaderMeta page={'score-report-verification'} meta={{ title: 'Score Report Verification' }} />
      <main className='main content__body-wrapper'>
        <div className='score-report-verification__container'>
          <iframe className='score-report-verification__iframe' src={`${SCORE_REPORT_VALIDATION_URL}?lang=${lang}`} allow="camera" />
        </div>
      </main>
    </>
  )
}

export default ScoreReportVerification;
